<template>
  <div>
    occur
  </div>
</template>

<script>

export default {
 
    name:'occurrenceName'
}
</script>

<style>

</style>